import React from "react";
import "./QuickAction.css";
function QuickActions() {
  return (
    <div className="quick-actions">
      <h4>Quick Actions</h4>
      <button>Upload New Accreditation</button>
      <button>View Analytics</button>
      <button>Edit Profile</button>
      <button>Join Home Healthcare Program</button>
    </div>
  );
}

export default QuickActions;
